import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { CruisesState } from './state/cruises.state';

/** Cruises phase 4 - the Cruises tab of the agency website (R-47 … R-57), on the Excursions page's pattern. QA doc features/cruises/qa.md. */
export const cruisesPageRouteConfig: Route = {
  path: 'cruises',
  loadComponent: () => import('./cruises-page.component').then((c) => c.CruisesPageComponent),
  providers: [provideStates([CruisesState])]
};
